<template>
  <div v-if="task" :href="task.url">
    <div class="new-task-offer">
      <div class="posts-bar">
        <div class="post-bar bgclr tw-shadow-xl tw-border-none">
          <div class="row d-flex">
            <div class="col-md-10 wordpressdevlp">
              <a :href="task.url">
                <h2>{{ task.category.title }}</h2>
              </a>
              <p>
                <i class="fa fa-clock"></i>Posted on
                <local-time :time="task.created_at"/>
              </p>
              <p>
                <i v-if="task.suburb && task.suburb.state && task.suburb.state.country"
                  class="fa fa-map-marker" style="padding-left: 1px;"/>
                {{ task.suburb.name }}, {{ task.suburb.state.abbreviation }}
              </p>
            </div>
            <div class="col-md-2 task-status-class">
              <!-- task status -->
              <p :class="'task-' + task.status_class">
                <i :class="task.status_class=='todo' ? 'fa fa-plus' :
								task.status_class=='inprogress' ? 'fa fa-hourglass' :
								task.status_class=='done' ? 'fa fa-check' :
								task.status_class=='canceled' ? 'fa fa-ban' : 'fa'"></i>
                {{ task.status_label }}
              </p>
              <!-- End task status -->
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="cadidatesbtn">
                <customer-review v-if="task.trader_id && !task.is_owner && task.status == 'done' && !task.is_customer_reviewed"
                  :task_id="task.id" @getType="getType"/>

                <done-task v-if="task.trader_id && task.is_owner && task.status == 'inprogress'" :task_id="task.id" @getType="getType"/>
                <a
                  v-if="task.is_owner"
                  :href="'/dashboard/offer?task_id=' + task.id"
                  :class="task.status == 'todo' ? 'btn btn-primary custom-btn' : 'btn btn-default custom-btn light-btn'"
                  style="position: relative;bottom: 2px;"
                >
                  <span class="badge badge-light">{{task.offers.length}}</span>
                  offers
                </a>
                <button v-else type="button" class="btn btn-primary custom-btn" style="padding-bottom:4px;">
                  <span class="badge badge-light">{{task.offers.length}}</span>
                  offers
                </button>
                <a v-if="user_id && user_id == task.user_id && task.status == 'todo'" href="#" @click.prevent="editTask(task)">
                  <i class="fa fa-edit"></i>
                </a>
                <a v-if="user_id && user_id == task.user_id && task.status == 'todo'" href="#" @click.prevent="showCancelModal">
                  <i class="fas fa-ban"></i>
                </a>
                <!-- budget -->
                <p v-if="task.budget" class="d-block ml-auto task-budget">
                  {{ task.budget.title }}
                </p>
                <!--End budget -->
              </div>
            </div>
            <vue-modal v-if="isCancelModalVisible" modal_title="Edit Task" container_style="margin:50px;min-width:60%;"
              body_container_style="margin:50px;min-width:60%;" @close="hideCancelModal">
              <template v-slot:header>
                <div></div>
              </template>
              <template v-slot:body>
                <cancel-task :task_id="task.id"></cancel-task>
              </template>
              <template v-slot:footer>
                <div></div>
              </template>
            </vue-modal>
            <div class></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LocalTime from "./../../LocalTime";
  import VueModal from "./../../VueModal";
  import EditTask from "./../task/EditTask";
  import CancelTask from "./../task/CancelTask";

  export default {
    components: {
      LocalTime,
      VueModal,
      EditTask,
      CancelTask
    },
    name: "task-card",
    props: {
      task: {
        type: Object,
        default: null
      }
    },
    methods: {
      getType: function (type) {
        this.type = type;
        let self = this;
        setTimeout(function () {
          self.type = null;
        }, 200);
      },
      editTask(task) {
        document.dispatchEvent(new CustomEvent('open-get-quote', {detail: task}))
      },
      showCancelModal() {
        this.isCancelModalVisible = true;
      },
      hideCancelModal() {
        this.isCancelModalVisible = false;
      }
    },
    data() {
      return {
        isCancelModalVisible: false,
        user_id: null,
        type: null
      };
    },
    created() {
      this.user_id = window.user_id;
    },
    watch: {
      type: {
        handler() {
          if (this.type != null || this.type != undefined) {
            this.$emit("getType", this.type);
          }
        }
      }
    }
  };
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
